(function (analytics) {
    "use strict";

    analytics.plugins = analytics.plugins || [];

    analytics.plugins.push(function () {
        /**
         * looks for the IRP events object on the page and sets the evars and events
         * @param trackingObject
         */

        if (typeof SiteCatPageInfo != "undefined") {

            console.log("nadex analytics: evars found on page: ", SiteCatPageInfo.lead_generated, SiteCatPageInfo.account_type);

            if (typeof SiteCatPageInfo.lead_generated != "undefined") {
                analytics.sitecatalyst.eVar13 = SiteCatPageInfo.lead_generated;
            } else {
              console.log("nadex analytics: lead_generated evar skipped");  
            }
            if (typeof SiteCatPageInfo.account_type != "undefined") {
                analytics.sitecatalyst.eVar16 = SiteCatPageInfo.account_type;  
            } else {
                console.log("nadex analytics: account_type evar skipped");  
            }

            console.log("nadex analytics: events found on page: ", SiteCatPageInfo.events);
            if (typeof SiteCatPageInfo.events != "undefined") {
                switch (SiteCatPageInfo.events) {
                    case "demo_acc":
                        //analytics.tracking.trackEvent('event2', '', ''); 
                        s.events = "event2";   
                        break;
                    case "full_acc":           
                        //analytics.tracking.trackEvent('event3', '', '');    
                        s.events = "event3";  
                        break;
                    case "lead_gen":            
                        //analytics.tracking.trackEvent('event6', '', '');
                        s.events = "event6";  
                        break;
                }   
            }                

        } else {
            //console.log("nadex analytics: irp evars not found");
        }

    });


})(window.nadex.marketing.analytics);
